"use strict";
import { usePasskeyAuthWithHelpModal } from "hooks/usePasskeyAuthWithHelpModal";
import { useEmbeddedWalletState } from "state/embeddedWallet/store";
import { disconnectWallet } from "uniswap/src/features/passkey/embeddedWallet";
import { logger } from "utilities/src/logger/logger";
export function useSignOutWithPasskey({ onSuccess, onError } = {}) {
  const { setIsConnected } = useEmbeddedWalletState();
  const { mutate: signOutWithPasskey, ...rest } = usePasskeyAuthWithHelpModal(
    async () => {
      await disconnectWallet();
      return true;
    },
    {
      onSuccess: () => {
        setIsConnected(false);
        onSuccess?.();
      },
      onError: (error) => {
        logger.error(error, {
          tags: {
            file: "useSignOutWithPasskey",
            function: "signOutWithPasskey"
          }
        });
        onError?.(error);
      }
    }
  );
  return { signOutWithPasskey, ...rest };
}
